<template>
  <div>
    <b-table :items="articles" :fields="fields">
      <template v-slot:cell(content)="data">{{ data.value }}</template>
      <template v-slot:cell(date)="data">{{ data.value | timeFilter }}</template>
      <template v-slot:cell(id)="data">
        <b-button-group>
          <b-button variant="primary" @click="editArticle(data.value)">修改</b-button>
          <b-button variant="danger" @click="deleteArticle(data.value)">删除</b-button>
        </b-button-group>
      </template>
    </b-table>
    <b-overlay :show="deleted" no-wrap></b-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      deleted: false,
      fields: [
        { key: "title", label: "文章标题" },
        { key: "date", label: "更新日期" },
        { key: "abstract", label: "内容概要" },
        { key: "id", label: "修改/删除" }
      ]
    };
  },
  computed: {
    ...mapState(["account", "articles"])
  },
  methods: {
    editArticle(id) {
      this.$router.push({ name: "AdminEdit", params: { id: id } });
    },
    deleteArticle(id) {
      this.$bvModal
        .msgBoxConfirm("是否删除该文章?", {
          okVariant: "danger",
          okTitle: "删除",
          cancelTitle: "取消",
          centered: true
        })
        .then(value => {
          if (value) {
            this.deleted = true;
            this.$store.dispatch("delArticle", id).then(() => {
              this.deleted = false;
            });
          }
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("clearFilterId");
    });
  }
};
</script>